import { render, staticRenderFns } from "./DefRegisterForm.vue?vue&type=template&id=5d2b72de&"
import script from "./DefRegisterForm.vue?vue&type=script&lang=js&"
export * from "./DefRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports